// extracted by mini-css-extract-plugin
module.exports = {"header":"Admin_header__7UMlQ","form":"Admin_form__fjCNk","icon":"Admin_icon__7LILx","login":"Admin_login__vB_9J"};